<template>
  <gs-modal class="gs-app" :value="open" title="Groove Help" subtitle="Ask a question about using Groove.cm." size="xl" @input="onVisibilityChange">
    <div v-if="open" class="groove-help">
      <div class="groove-help__status">
        <p v-if="!loaded" role="status">{{ failed ? 'Chat could not load. Open it in a new tab below.' : 'Loading Groove Help…' }}</p>
        <a :href="chatUrl" target="_blank" rel="noopener noreferrer">Open chat in a new tab <gs-icon name="external-link" size="14" /></a>
      </div>
      <iframe
        :src="chatUrl"
        title="Groove.cm"
        allow="microphone; clipboard-write"
        class="groove-help__frame"
        @load="loaded = true"
        @error="failed = true"
      />
    </div>
  </gs-modal>
</template>

<script>
import createAccessibleModal from '../../../groove-ui-kit-v2/src/vue2/accessible-modal';
export const CHAT_URL = 'https://chatbaser.ai/chat/e25758cf-27f6-4810-bd15-50357df3d4b5?mode=widget';

export default {
  name: 'GrooveHelpModal',
  components: { GsModal: createAccessibleModal() },
  props: { open: Boolean },
  data() {
    return { loaded: false, failed: false, chatUrl: CHAT_URL };
  },
  watch: {
    open() {
      this.loaded = false;
      this.failed = false;
    },
  },
  methods: {
    onVisibilityChange(value) {
      if (!value) this.$emit('close');
    },
  },
};
</script>

<style scoped>
.groove-help { padding: 20px 28px 28px; }
.groove-help__status { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 8px 16px; margin-bottom: 14px; }
.groove-help__status p { margin: 0; color: var(--gs-muted-foreground); font-size: 13px; }
.groove-help__status a { display: inline-flex; align-items: center; gap: 6px; color: var(--gs-active); font-size: 13px; min-height: 40px; }
.groove-help__status a:focus-visible { outline: 3px solid var(--gs-ring); outline-offset: 3px; }
.groove-help__frame { display: block; width: 100%; height: min(65vh, 680px); min-height: 280px; border: 1px solid var(--gs-border); border-radius: var(--gs-radius-md); background: var(--gs-surface); }
@media (max-width: 640px) {
  .groove-help { padding: 16px 18px 24px; }
  .groove-help__frame { height: 58vh; min-height: 240px; }
}
</style>
